import '@/scss/taxonomy/brand/brand.scss';
import {loadMore} from "@/js/taxonomy/brand/components/loadMore";
import {newProductsSwiper} from "@/js/pages/home/components/newProductsSwiper";
import {faq} from "@/js/global/components/faq";

loadMore();
newProductsSwiper();
faq();